import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/LoginPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import Dashboard from './components/Dashboard';
import ReportView from './components/ReportView';
import AdminUsersPage from './components/AdminUsersPage';
import AccountSettingsPage from './components/AccountSettingsPage';
import AcceptInvitePage from './components/AcceptInvitePage';
import SsoCallback from './components/SsoCallback';

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    // Public — receives the on-prem portal SSO redirect. Not wrapped in
    // ProtectedRoute because it runs *before* auth state is established.
    path: "/sso-callback",
    element: <SsoCallback />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  },
  {
    path: "/report/:reportId",
    element: (
      <ProtectedRoute>
        <ReportView />
      </ProtectedRoute>
    )
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <AccountSettingsPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/admin/users",
    element: (
      <ProtectedRoute requiredRole="admin">
        <AdminUsersPage />
      </ProtectedRoute>
    )
  },
  {
    path: "/invite/:token",
    element: <AcceptInvitePage />
  },
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />
  }
]);

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </AuthProvider>
  );
}

export default App;